import axios from "axios";
import KeycloakLib from "@/libs/Keycloak";
import { Message } from "./utils";
import { initLoader } from "./utils";

let url = process.env.VUE_APP_API_URL;
let url_cms = process.env.VUE_APP_API_CMS_URL;

let cms_headers = async () => {
  const { store } = await import("@/store");
  return {
    Authorization: "Bearer " + KeycloakLib.getToken()
  };
};

let headers = async () => {
  const { store } = await import("@/store");
  return {
    Authorization: "Bearer " + KeycloakLib.getToken(),
    "X-sc-id": store.getters["schoolAuth/getScId"],
    "X-school-uuid": store.getters["schoolAuth/getScId"],
    locale: store.state.switchLanguage.localeConfig,
    "X-role-id": store.getters["user/roleId"][0]
  };
};

let cms_get = async function get(
  path = "/",
  params = {},
  auth = true,
  header = {},
  responseType = "json",
  errMsg = null,
  overlayLoading = true,
  showErrMsg = true
) {
  let loader = overlayLoading ? initLoader() : null;

  return axios({
    method: "get",
    url: url_cms + path,
    params: params,
    headers: auth ? { ...(await cms_headers()), ...header } : {},
    responseType: responseType
  })
    .catch(function(e) {
      if (showErrMsg) _handleErrorResponse(e, errMsg);
    })
    .finally(function() {
      loader && loader.hide();
    });
};

let get = async function get(
  path = "/",
  params = {},
  auth = true,
  header = {},
  responseType = "json",
  errMsg = null,
  overlayLoading = true,
  showErrMsg = true
) {
  let loader = overlayLoading ? initLoader() : null;

  return axios({
    method: "get",
    url: url + path,
    params: params,
    headers: auth ? { ...(await headers()), ...header } : {},
    responseType: responseType
  })
    .catch(function(e) {
      if (showErrMsg) _handleErrorResponse(e, errMsg);
    })
    .finally(function() {
      loader && loader.hide();
    });
};

let post = async function post(
  path = "/",
  data = {},
  auth = true,
  header = {},
  responseType = "json",
  errMsg = null,
  overlayLoading = true
) {
  let loader = overlayLoading ? initLoader() : null;

  return axios({
    method: "post",
    url: url + path,
    data: data,
    headers: auth ? { ...(await headers()), ...header } : {},
    responseType: responseType
  })
    .catch(e => {
      _handleErrorResponse(e, errMsg);
    })
    .finally(function() {
      loader && loader.hide();
    });
};

let cms_post = async function post(
  path = "/",
  data = {},
  auth = true,
  header = {},
  responseType = "json",
  errMsg = null,
  overlayLoading = true
) {
  let loader = overlayLoading ? initLoader() : null;

  return axios({
    method: "post",
    url: url_cms + path,
    data: data,
    headers: auth ? { ...(await headers()), ...header } : {},
    responseType: responseType
  })
    .catch(e => {
      _handleErrorResponse(e, errMsg);
    })
    .finally(function() {
      loader && loader.hide();
    });
};

let put = async function put(
  path = "/",
  data = {},
  auth = true,
  header = {},
  errMsg = null,
  overlayLoading = true
) {
  let loader = overlayLoading ? initLoader() : null;

  return axios({
    method: "put",
    url: url + path,
    data: data,
    headers: auth ? { ...(await headers()), ...header } : {}
  })
    .catch(function(e) {
      _handleErrorResponse(e, errMsg);
    })
    .finally(function() {
      loader && loader.hide();
    });
};

let patch = async function patch(
  path = "/",
  data = {},
  auth = true,
  header = {},
  errMsg = null,
  overlayLoading = true
) {
  let loader = overlayLoading ? initLoader() : null;

  return axios({
    method: "patch",
    url: url + path,
    data: data,
    headers: auth ? { ...(await headers()), ...header } : {}
  })
    .catch(function(e) {
      _handleErrorResponse(e, errMsg);
    })
    .finally(function() {
      loader && loader.hide();
    });
};

let del = async function del(
  path = "/",
  data = {},
  auth = true,
  header = {},
  errMsg = null,
  overlayLoading = true
) {
  let loader = overlayLoading ? initLoader() : null;

  return axios({
    method: "delete",
    url: url + path,
    data: data,
    headers: auth ? { ...(await headers()), ...header } : {}
  })
    .catch(function(e) {
      _handleErrorResponse(e, errMsg);
    })
    .finally(function() {
      loader && loader.hide();
    });
};

let request = async function request(
  url,
  method,
  data = {},
  auth = true,
  errMsg = null
) {
  let loader = initLoader();

  return axios({
    method: method,
    url: url,
    data: data,
    headers: auth ? await headers() : {}
  })
    .catch(function(e) {
      _handleErrorResponse(e, errMsg);
    })
    .finally(function() {
      loader.hide();
    });
};

let _showErrorNotify = function(message) {
  Message.error(message);
};

let _handleErrorResponse = function(e, passedErrMsg) {
  if (!e.response) {
    return;
  }

  if (e.response.status === 401) {
    _showErrorNotify(
      "Bạn không có quyền sử dụng chức năng này. Vui lòng đăng nhập lại"
    );
    window.location.href = window.location.origin;
    return;
  }

  let response = e.response.data;
  let errorMsgs = response.errors || response.message || response.messages;

  if (typeof errorMsgs === "object") {
    const errors = Object.values(errorMsgs);
    const firstErrors = errors && errors[0];
    // check if first errors is array or string;
    const errMsg = firstErrors
      ? firstErrors instanceof Array
        ? firstErrors[0]
        : firstErrors
      : "";

    _showErrorNotify(errMsg || passedErrMsg || "Some thing went wrong...");
  } else {
    _showErrorNotify(passedErrMsg || errorMsgs);
  }

  // CUSTOM HERE OR THROW original error;
  throw e;
};

let $axios = {
  get: get,
  post: post,
  put: put,
  patch,
  delete: del,
  request: request,
  getHeaderCfg: headers,
  cms_get: cms_get,
  cms_post: cms_post
};

export default $axios;
